import { render } from "./JumlahKutipanWidget.vue?vue&type=template&id=201be458"
import script from "./JumlahKutipanWidget.vue?vue&type=script&lang=js"
export * from "./JumlahKutipanWidget.vue?vue&type=script&lang=js"

import "./JumlahKutipanWidget.vue?vue&type=style&index=0&id=201be458&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__